import React from "react";

const HowItWorks = () => {
  return (
    <section className="sx-how-section">
      <div className="sx-how-container">
        {/* HEADER */}
        <div className="sx-how-head">
          <h2>How It Works</h2>
          <p>
            Getting professional printer help is simple. Follow these easy steps
            and our team will take care of the rest.
          </p>
        </div>

        {/* STEPS */}
        <div className="sx-how-grid">
          <div className="sx-how-card">
            <span className="sx-how-step">01</span>
            <h4>Submit Your Request</h4>
            <p>
              Fill out the service form with your contact details and printer
              information so we understand your requirement clearly.
            </p>
          </div>

          <div className="sx-how-card">
            <span className="sx-how-step">02</span>
            <h4>We Contact You</h4>
            <p>
              Our team reviews your request and contacts you to confirm the
              issue, service availability, and next steps.
            </p>
          </div>

          <div className="sx-how-card">
            <span className="sx-how-step">03</span>
            <h4>Setup & Guide</h4>
            <p>
              A qualified technician provides printer setup, configuration, or
              troubleshooting.
            </p>
          </div>

          <div className="sx-how-card">
            <span className="sx-how-step">04</span>
            <h4>Get Back to Printing</h4>
            <p>
              Once the issue is resolved, you can continue printing smoothly
              with confidence and minimal downtime.
            </p>
          </div>
        </div>
      </div>

      {/* CSS */}
      <style>{`
        /* ================= SECTION ================= */
        .sx-how-section {
          padding: 90px 0;
          background: #ffffff;
        }

        .sx-how-container {
          max-width: 1100px;
          margin: auto;
          padding: 0 20px;
        }

        /* HEADER */
        .sx-how-head {
          text-align: center;
          margin-bottom: 60px;
        }

        .sx-how-head h2 {
          font-size: 36px;
          font-weight: 800;
          color: #111827;
          margin-bottom: 10px;
        }

        .sx-how-head p {
          font-size: 16px;
          color: #6b7280;
          max-width: 620px;
          margin: auto;
          line-height: 1.7;
        }

        /* GRID */
        .sx-how-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 30px;
        }

        .sx-how-card {
          background: #f9fafb;
          padding: 30px 32px;
          border-radius: 14px;
          transition: transform .25s ease, box-shadow .25s ease;
        }

        .sx-how-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 16px 35px rgba(0,0,0,0.08);
        }

        .sx-how-step {
          display: inline-block;
          font-size: 22px;
          font-weight: 800;
          color: #2563eb;
          margin-bottom: 12px;
        }

        .sx-how-card h4 {
          font-size: 18px;
          font-weight: 700;
          color: #111827;
          margin-bottom: 8px;
        }

        .sx-how-card p {
          font-size: 15px;
          line-height: 1.7;
          color: #4b5563;
          margin: 0;
        }

        /* MOBILE */
        @media(max-width: 700px) {
          .sx-how-grid {
            grid-template-columns: 1fr;
          }

          .sx-how-head h2 {
            font-size: 28px;
          }
        }
      `}</style>
    </section>
  );
};

export default HowItWorks;
